import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModalModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { DictionaryCreateModalComponent } from './dictionary-create-modal.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { NgSelectModule } from '@ng-select/ng-select';



@NgModule({
  declarations: [
    DictionaryCreateModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModalModule,
    PipesModule,
    NgbTypeaheadModule,
    NgSelectModule
  ],
  exports: [DictionaryCreateModalComponent]

})
export class DictionaryCreateModalModule { }
